import {
  DOMAIN_REGEX,
  EMAIL_REGEX,
  FREEMAIL_DOMAINS,
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
} from "../constants";

export type Fields = {
  company_name: string;
  company_domain: string;
  email: string;
};

export type FieldErrors = Partial<Record<keyof Fields, string>>;

export function normalizeDomain(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, "")
    .replace(/^www\./, "")
    .replace(/\/.*$/, "");
}

export function validateField(
  field: keyof Fields,
  rawValue: string
): string | null {
  const value = rawValue.trim();
  switch (field) {
    case "company_name": {
      if (value.length < NAME_MIN_LENGTH) return "Please enter a company name";
      if (value.length > NAME_MAX_LENGTH) return "Company name is too long";
      return null;
    }
    case "company_domain": {
      if (!value) return "Enter your company domain";
      const normalized = normalizeDomain(value);
      if (!DOMAIN_REGEX.test(normalized))
        return "Enter a valid domain like example.com";
      return null;
    }
    case "email": {
      if (!value) return "Enter your work email";
      if (!EMAIL_REGEX.test(value)) return "Enter a valid email";
      const domain = value.split("@")[1]?.toLowerCase();
      if (domain && FREEMAIL_DOMAINS.has(domain))
        return "Please use your work email";
      return null;
    }
  }
}

export function validateAll(fields: Fields): FieldErrors {
  const errors: FieldErrors = {};
  (Object.keys(fields) as (keyof Fields)[]).forEach((key) => {
    const err = validateField(key, fields[key]);
    if (err) errors[key] = err;
  });
  return errors;
}
